import constants from '../constants';

import { IfmsConfig } from './types';

import { stringsStartsWithIgnoreCase } from '../util';
import PeriodClosingDetails from "../components/accounting/reports/ClosingPeriod";
import YearEndProcessingDetails from "../components/accounting/reports/YearEndProcessing";
import { JobNames } from '../framework.core/JobNames';
import { FmsSecTask } from '../fms.core/constants';
import { FmsSubMenu } from '../constants/fmsSubMenu';
import { borderColors } from '../ui/ActionButton';
// let serverUrl = 'http://192.168.167.128:5000/api/';
// let serverUrl = 'http://cloud.suntekscm.co.kr/api/';
//let serverUrl = 'http://127.0.0.1:5000/api/';
//let serverUrl = 'https://ifms.suntekscm.co.kr/api/';
 let serverUrl = 'http://localhost:5000/api/';

// //<pt220328: To test under same hostname with serverUrl value>
// if (serverUrl !== 'http://localhost:5000/api/' && process.env.NODE_ENV === 'production') {
//   serverUrl = 'http://localhost:5000/api/';
// }

//<231201.dwshin. serverUrl auto setting.>
if (process.env.NODE_ENV === 'production') {
  serverUrl = `${window.location.origin}/api/`;
}

// For add icons
export enum IconTypes {
  Flag = 'flag',
  Shield = 'shield',
  multiplewindows = 'multiplewindows',
}

const config: IfmsConfig = {
  serverUrl,
  // 250718.inhyung. Issue#2558 Quick Menu text 개선을 위해 dash2 url 수정.
  dashboardUrl: 'https://dash2.suntekscm.com/Base/DashBoard?ver=5003',
  dashboardUrlDark: 'https://dash2.suntekscm.com/Base/DashBoard?ver=5004',
  menus: [
    // Ocean Import
    {
      operation: constants.operations.oceanImport,
      job: [
        {
          text: 'Master B/L',
          name: 'mbl',
          level: 0,
          link: '/common/joblistview/mbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/mbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIMbl,
          moreMenuJobName: JobNames.OIMbl,
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'House B/L',
          name: 'hbl',
          level: 0,
          link: '/common/joblistview/hbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/hbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIHbl,
          moreMenuJobName: JobNames.OIHbl,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.oceanImport,
        },        
        {
          text: 'OI Quotation',
          name: 'quot',
          level: 0,
          link: '/common/joblistview/oiQuotation/oceanImport?parentOp=oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oiQuotation/oceanImport'),
          fmsSecTask: FmsSecTask.OIQuot,
          topLineColor: borderColors[1 % borderColors.length],
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'Container List (OI)',
          name: 'cntr',
          level: 0,
          link: '/common/joblistview/OICN/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OICN/oceanImport'),
          fmsSecTask: FmsSecTask.OIContainer,
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'Load Plan',
          name: 'loadPlan',
          level: 0,
          link: '/common/joblistview/OILD/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OILD/oceanImport'),
          fmsSecTask: FmsSecTask.OITruckLoad,
          topLineColor: borderColors[2 % borderColors.length],
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'Vessel Info',
          name: 'vessel',
          level: 0,
          link: '/common/joblistview/OIVS/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIVS/oceanImport'),
          fmsSecTask: FmsSecTask.OIVessel,
          topLineColor: borderColors[2 % borderColors.length],
          secTaskGroup: constants.operations.oceanImport,
        },
        // {
        //   text: 'Invoice',
        //   name: 'inv',
        //   level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
        // },
        // {
        //   text: 'Bill',
        //   name: 'bil',
        //   level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
        // },
        // {
        //   text: 'CrDb',
        //   name: 'crdb',
        //   level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
        // },
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4',
          secTaskGroup: ''
        },
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4',
          secTaskGroup: ''
        },
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
          secTaskGroup: ''
        },
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
          secTaskGroup: ''
        },
        {
          text: 'AMS',
          level: 0,
          topLineColor: borderColors[4 % borderColors.length],
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          iconImg: IconTypes.Shield,
          //textColor: 'orangered',
          items: [
            // {
            //   text: 'AMS Filing',
            //   name: 'amsFiling',
            //   level: 1,
            //   subMenu: FmsSubMenu.AmsFiling,
            // },
            // {
            //   text: 'Voyage',
            //   name: 'voyage',
            //   level: 1,
            //   link: '/common/joblistview/AMSV/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSV/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSVoyage,
            // },
            // {
            //   text: 'MBL',
            //   name: 'amsMbl',
            //   level: 1,
            //   link: '/common/joblistview/AMSM/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSM/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSMaster,
            // },
            // {
            //   text: 'HBL',
            //   name: 'amsHbl',
            //   level: 1,
            //   link: '/common/joblistview/AMSH/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSH/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSHouse,
            // },
            // {
            //   text: 'User',
            //   name: 'amsUser',
            //   level: 1,
            //   link: '/common/joblistview/AMSU/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSU/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSUser,
            // },
            // {
            //   text: 'AMS Branch',
            //   name: 'amsBranch',
            //   level: 1,
            //   link: '/common/joblistview/AMBR/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBR/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSBranch,
            // },
            // {
            //   text: 'AMS Billing Code',
            //   name: 'amsBilling',
            //   level: 1,
            //   link: '/common/joblistview/AMBI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBI/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSBilling,
            // },
            // {
            //   text: 'Filing History',
            //   name: 'amsFileHistory',
            //   level: 1,
            //   link: '/common/joblistview/AMHI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMHI/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSHistory,
            // },
            // {
            //   text: 'Customs Release History',
            //   name: 'amsCustHistory',
            //   level: 1,
            //   link: '/common/joblistview/AMC1/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMC1/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSC1History,
            // }, {
            //   text: 'Usage Report',
            //   level: 1,
            //   link: '/oceanImport/amsUsageReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsUsageReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptUsage
            // }, {
            //   text: 'Lifting Report',
            //   level: 1,
            //   link: '/oceanImport/amsLiftReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsLiftReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptLifting
            // }, {
            //   text: 'Total Lifting Report',
            //   level: 1,
            //   link: '/oceanImport/amsTotLiftReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsTotLiftReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptTotalLifting
            // },
          ],
          secTaskGroup: ''

        },
        {
          text: 'ACI eManifest', level: 0,
          topLineColor: borderColors[4 % borderColors.length],
          name: 'aci',
          iconImg: IconTypes.Shield,
          fmsSecTask: FmsSecTask.ACIManifest,
          link: '/common/joblistview/ACIEM/ams',
          //textColor: 'orangered',
          items: [
            // {
            //   text: 'Voyage List',
            //   level: 1,
            //   link: '/common/joblistview/ACIV/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIV/oceanImport')
            // },
            // {
            //   text: 'MBL List',
            //   level: 1,
            //   link: '/common/joblistview/ACIM/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIM/oceanImport')
            // },
            // {
            //   text: 'House Bill',
            //   name: 'aciHbl',
            //   level: 1,
            //   link: '/common/joblistview/ACIEM/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIEM/oceanImport'),
            //   fmsSecTask: FmsSecTask.ACIManifest,
            //   secTaskGroup: ''
            // },
            // {
            //   text: 'Users',
            //   level: 1,
            //   link: '/common/joblistview/ACIU/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIU/oceanImport')
            // },
            // {
            //   text: 'Branch',
            //   level: 1,
            //   link: '/common/joblistview/ACBR/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACBR/oceanImport')
            // },
            // {
            //   text: 'ACI Filing History',
            //   level: 1,
            //   link: '/common/joblistview/ACHI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACHI/oceanImport')
            // },
            // {
            //   text: 'ACI eManifest Usage Report',
            //   level: 1,
            //   link: '/oceanImport/aciUsageReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/aciUsageReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptUsage,
            //   secTaskGroup: ''
            // },
            // {
            //   text: 'ACI eManifest Usage Report', 
            //   name:'aciUsageReport',
            //   level: 1, 
            //   popupComponent: <UsageReport mode={"ACI"} />, 
            //   fmsSecTask: FmsSecTask.AMSRptUsage},
            // {text: 'Lifting Report', level: 1},
            // {text: 'Total ACI Lifting', level: 1},
          ],
          secTaskGroup: ''
        },
        {
          text: 'ISF',
          name: 'isf',
          level: 0,
          topLineColor: borderColors[4 % borderColors.length],
          link: '/common/joblistview/ISFL/isf',
          iconImg: IconTypes.Shield,
          //textColor: 'orangered',
          items: [
            // {
            //   text: 'ISF Filing',
            //   name: 'isfFiling',
            //   level: 1,
            //   subMenu: FmsSubMenu.IsfFiling,
            // },
            // {
            //   text: 'ISF List',
            //   name: 'isfList',
            //   level: 1,
            //   link: '/common/joblistview/ISFL/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ISFL/oceanImport'),
            //   fmsSecTask: FmsSecTask.ISF,
            // },
          ],
          secTaskGroup: ''
        },
        {
          text: `In-bond`,
          level: 0,
          topLineColor: borderColors[4 % borderColors.length],
          name: 'inbond',
          iconImg: IconTypes.Shield,
          //textColor: 'orangered',
          metadata: { isDirectPrint: true },
          secTaskGroup: ''
        },
        {
          text: 'Report', level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          name: 'report',
          items: [
            {
              text: 'Arrival Notice Log',
              level: 1,
              link: '/oceanImport/arrivalnoticelog',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalnoticelog/'),
              fmsSecTask: FmsSecTask.OIRptANLog,
              secTaskGroup: constants.operations.oceanImport,
            }, {
              text: 'Inland Transportation',
              level: 1,
              link: '/oceanImport/inlandTransportation',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/inlandTransportation/'),
              fmsSecTask: FmsSecTask.OIRptInlandTransport,
              secTaskGroup: constants.operations.oceanImport,
            }, {
              text: 'Ocean Import ETA/ETD',
              level: 1,
              link: '/oceanImport/shipmentReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/shipmentReport/'),
              fmsSecTask: FmsSecTask.OIRptShipment,
              secTaskGroup: constants.operations.oceanImport,
            }, {
              text: 'Pending Cargo',
              level: 1,
              link: '/oceanImport/pendingCargo',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pendingCargo/'),
              fmsSecTask: FmsSecTask.OIRptPendingCargo,
              secTaskGroup: constants.operations.oceanImport,
            }, {
              text: 'Release History',
              level: 1,
              link: '/oceanImport/releaseHistory',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/releaseHistory/'),
              fmsSecTask: FmsSecTask.OIRptRlsHistory,
              secTaskGroup: constants.operations.oceanImport,
            },],
          nonItemThenHide: true,
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'Download MBL',
          level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          link: '/common/joblistview/OIMP/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIMP/oceanImport'),
          fmsSecTask: FmsSecTask.OIMPims,
          secTaskGroup: constants.operations.oceanImport,
        },
        {
          text: 'Download HBL',
          level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          link: '/common/joblistview/OIHP/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIHP/oceanImport'),
          fmsSecTask: FmsSecTask.OIHPims,
          secTaskGroup: constants.operations.oceanImport,
        },
      ],
      operationReport: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   topLineColor: '#007BFF',
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      moreMenu: [
        //Oim More Menu
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/oceanImport/arrivalNotice?jobname=@jobName&id=@jobid&isAtme=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalnotice/'),
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/correctionNotice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Master Invoice',
          level: 1,
          link: '/oceanImport/masterinvoice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/masterinvoice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pickupDelivery/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'USDA Hold Notice',
          level: 1,
          link: '/oceanImport/mblholdnotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/mblholdnotice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OIMbl, },
        //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.OIMbl },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'Cargo Manifest',
          level: 1,
          subMenu: FmsSubMenu.OICargoManifest,
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OIMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/folderLabel/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanImport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoList/'),
          moreMenuJobName: JobNames.OIMbl
        },
        { text: 'Out of State Log', level: 1, subMenu: FmsSubMenu.OutOfStateLog, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'CBP Status Query',
          level: 1,
          //textColor: 'orangered',
          link: '/oceanImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[3 % borderColors.length],
          iconImg: IconTypes.Shield,
        },
        //appcontext on off menu
        { text: 'CFS Manifest', level: 1, subMenu: FmsSubMenu.STARCFSMANI, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'Devanning Instruction',
          level: 1,
          link: '/oceanImport/devanninginstruction?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/devanninginstruction/'),
          moreMenuJobName: JobNames.OIMbl
        },

        //Oih More Menu
        // { text: 'Arrival Notice', level: 1, popupComponent: <HblArrivalNotice jobName={JobNames.OIHbl} selectedElement={null} />, popupLabel: 'Arrival Notice (HBL)', moreMenuJobName: JobNames.OIHbl, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/oceanImport/hblArrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/hblArrivalNotice/'),
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        {
          text: 'Arrival Notice',
          level: 1,
          moreMenuJobName: JobNames.OIHbl,
          subMenu: FmsSubMenu.ArrivalNotice
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        // { text: 'Arrival/Release Notice', level: 1, popupComponent: <ArrivalReleaseNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Arrival/Release Notice',
          level: 1,
          link: '/oceanImport/arrivalReleaseNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalReleaseNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Arrival Notice (2nd)', level: 1, subMenu: FmsSubMenu._2ndArrivalNotice, moreMenuJobName: JobNames.OIHbl },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/correctionNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Delivery Order (Pre Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OIHbl} selectedElement={null} docType={DocumentType.DO} />, moreMenuJobName: JobNames.OIHbl },
        // {
        //   text: 'Delivery Order (Pre Form)',
        //   level: 1,
        //   link: '/oceanImport/preDeliveryOrder?jobname=@jobName&id=@jobid&docType=59',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/preDeliveryOrder/'),
        //   moreMenuJobName: JobNames.OIHbl
        // },
        // { text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OIHbl} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Delivery Order',
          level: 1,
          link: '/oceanImport/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OIHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pickupDelivery/'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Print HBL', level: 1, subMenu: FmsSubMenu.OIHouseBL, moreMenuJobName: JobNames.OIHbl },
        //{ text: 'USDA Hold Notice', level: 1, popupComponent: <HblHoldNotice selectedElement={null} />, popupLabel: 'USDA Hold Notice (HBL)', moreMenuJobName: JobNames.OIHbl },
        {
          text: 'USDA Hold Notice',
          level: 1,
          link: '/oceanImport/hblHoldNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/hblHoldNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        //{ text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.OIHbl, },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.OIHbl, },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.OIHbl} />, moreMenuJobName: JobNames.OIHbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          //textColor: 'orangered',
          link: '/oceanImport/cargoManifestStatus?jobname=@jobName&id=@jobid&oiMblId=@oiMblId',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
        },
        //appcontext on off menu
        {
          text: 'CFS Release', level: 1, moreMenuJobName: JobNames.OIHbl,
          name: 'cfsRelease', popupWidth: 900,
          popupComponent: <></>
        },
        //appcontext on off menu
        //{ text: 'EDI 315', level: 1, popupComponent: <SendShipmentStatus />, popupWidth: 760, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'EDI 315',
          level: 1, 
          link: '/oceanImport/sendShipmentStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/sendShipmentStatus'),
          moreMenuJobName: JobNames.OIHbl
        },
        {
          text: 'Carrier\'s Certificate',
          level: 1,
          subMenu: FmsSubMenu.CarrierCertificate,
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        // { text: 'Empty CNTR Return Guarantee', level: 1, popupComponent: <EmptyContainerReturnGuarantee selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Empty CNTR Return Guarantee',
          level: 1,
          link: '/oceanImport/emptyContainerReturnGuarantee?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/emptyContainerReturnGuarantee'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.OIHbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OIHbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/folderLabel/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'I.T Cancel Notice', level: 1, popupComponent: <CancelNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'I.T Cancel Notice',
          level: 1,
          link: '/oceanImport/cancelNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cancelNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.OIHbl} selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/oceanImport/itTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/itTeNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Lien Notice', level: 1, popupComponent: <LienNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Lien Notice',
          level: 1,
          link: '/oceanImport/lienNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/lienNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OIHbl} />, popupLabel: 'Memo List (HBL)', moreMenuJobName: JobNames.OIHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanImport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoList/'),
          moreMenuJobName: JobNames.OIHbl
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/oceanImport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoCustomerList/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/oceanImport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/packageLabel/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Preliminary Claim Notice', level: 1, popupComponent: <PreliminaryClaimNotice jobName={JobNames.OIHbl} selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Preliminary Claim Notice',
          level: 1,
          link: '/oceanImport/preliminaryClaimNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/preliminaryClaimNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Proof of Delivery', level: 1, popupComponent: <ProofOfDelivery selectedElement={null} jobName={JobNames.OIHbl} />, popupWidth: 790, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Proof of Delivery',
          level: 1,
          link: '/oceanImport/proofOfDelivery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/proofOfDelivery/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Release Order/Turnover', level: 1, popupComponent: <ReleaseOrderTurnover jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Release Order/Turnover',
          level: 1,
          link: '/oceanImport/releaseOrderTurnover?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/releaseOrderTurnover/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/oceanImport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/straightBl/'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Work Sheet', level: 1, subMenu: FmsSubMenu.WorkSheet, moreMenuJobName: JobNames.OIHbl },
        // {
        //   text: 'ISF Usage',
        //   level: 1,
        //   link: '/oceanImport/isfUsage?jobname=@jobName',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/isfUsage'),
        //   moreMenuJobName: JobNames.ISF
        // },
        //Download MBL More Menu
        // { text: 'Download MBL (All) List', level: 1, moreMenuJobName: JobNames.OIMPims },
        // { text: 'Download MBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OIMPims },
        // { text: 'Download MBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OIMPims },

        //Download HBL More Menu
        // { text: 'Download HBL (All) List', level: 1, moreMenuJobName: JobNames.OIHPims },
        // { text: 'Download HBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OIHPims },
        // { text: 'Download HBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OIHPims },

        // [Issue#3437] -> 2026-04-01 jhchoi : 회장님 지시로 다시 복구
        {
          text: `ISF 10 Filing`,
          name: 'isf10Filing',
          level: 1,
          subMenu: FmsSubMenu.Isf10Filing,
          moreMenuJobName: JobNames.OIHbl,
          iconImg: IconTypes.Shield,
        },
        {
          text: `ISF 5 Filing`,
          name: 'isf5Filing',
          level: 1,
          subMenu: FmsSubMenu.Isf5Filing,
          moreMenuJobName: JobNames.OIHbl,
          iconImg: IconTypes.Shield,
        },
      ]
    },
    // Ocean export
    {
      operation: constants.operations.oceanExport,
      job: [
        {
          text: 'House B/L',
          level: 0,
          link: '/common/joblistview/oeHbl/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeHbl/oceanExport'),
          fmsSecTask: FmsSecTask.OEHbl,
          moreMenuJobName: JobNames.OEHbl,
          secTaskGroup: constants.operations.oceanExport,
        },
        {
          text: 'Master B/L',
          level: 0,
          link: '/common/joblistview/oeMbl/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeMbl/oceanExport'),
          fmsSecTask: FmsSecTask.OEMbl,
          moreMenuJobName: JobNames.OEMbl,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.oceanExport
        },
        {
          text: 'Booking (S/O)',
          level: 0,
          link: '/common/joblistview/oeBooking/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeBooking/oceanExport'),
          fmsSecTask: FmsSecTask.OEBook,
          moreMenuJobName: JobNames.OEBook,
          topLineColor: borderColors[1 % borderColors.length],
          secTaskGroup: constants.operations.oceanExport
        },
        {
          text: 'OE Quotation',
          level: 0,
          link: '/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeQuotation/oceanExport'),
          fmsSecTask: FmsSecTask.OEQuot,
          topLineColor: borderColors[2 % borderColors.length],
          secTaskGroup: constants.operations.oceanExport
        },
        {
          text: 'Container List (OE)',
          level: 0,
          link: '/common/joblistview/OECN/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OECN/oceanExport'),
          fmsSecTask: FmsSecTask.OEContainer,
          secTaskGroup: constants.operations.oceanExport
        },
        {
          text: 'Load Plan',
          level: 0,
          link: '/common/joblistview/oeLoadPlan/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeLoadPlan/oceanExport'),
          fmsSecTask: FmsSecTask.OELoad,
          secTaskGroup: constants.operations.oceanExport
        },
        // {
        //   text: 'Invoice',
        //   level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
        // },
        // {
        //   text: 'Bill',
        //   level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
          
        // },
        // {
        //   text: 'CrDb',
        //   level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   topLineColor: borderColors[3 % borderColors.length],
        //   secTaskGroup: ''
        // },
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4',
          secTaskGroup: ''
        },
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4',
          secTaskGroup: ''
        },
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
          secTaskGroup: ''
        },
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
          secTaskGroup: ''
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          //textColor: 'orangered',
          link: '/common/joblistview/AMSM/ams',
          topLineColor: borderColors[4 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: ''
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          //textColor: 'orangered',
          link: '/common/joblistview/ISFL/isf',
          topLineColor: borderColors[4 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: ''
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          metadata: { isDirectPrint: true },
          topLineColor: borderColors[4 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: ''
        },
        {
          text: 'Report',
          level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          secTaskGroup: constants.operations.oceanExport,
          items: [
            {
              text: 'Ocean Export Shipment',
              level: 1,
              link: '/oceanExport/shipmentReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shipmentReport/'),
              fmsSecTask: FmsSecTask.OERptShipment,
              secTaskGroup: constants.operations.oceanExport,
            }, {
              text: 'Brokerage',
              level: 1,
              link: '/oceanExport/brokerageReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/brokerageReport/'),
              fmsSecTask: FmsSecTask.OERptBrokerage,
              secTaskGroup: constants.operations.oceanExport,
            },
            // {text: 'Est. Profit/Volume Summary Report', level: 1},
          ],
          nonItemThenHide: true
        },
        {
          text: 'Download MBL',
          level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          link: '/common/joblistview/OEMP/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OEMP/oceanExport'),
          fmsSecTask: FmsSecTask.OEMPims,
          secTaskGroup: constants.operations.oceanExport,
        },
        {
          text: 'Download HBL',
          level: 0,
          topLineColor: borderColors[5 % borderColors.length],
          link: '/common/joblistview/OEHP/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OEHP/oceanExport'),
          fmsSecTask: FmsSecTask.OEHPims,
          secTaskGroup: constants.operations.oceanExport,
        },
        /*{
          text: 'Booking Status', level: 0,
          items: [
            { text: 'Customer Booking ', level: 1 },
            { text: 'Carrier Booking ', level: 1 },
          ]
        },*/
        // {
        //   text: 'Load Plan', level: 0,
        // },
        /*{
            text: '	W/H Receipt', level: 0,
        },
        {
            text: 'Container Tracking', level: 0,
        },*/
      ],
      operationReport: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      moreMenu: [
        //Oem More Menu
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/correctionNotice/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEMbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Batch Print House B/L', level: 1, popupComponent: <OemBatchPrint jobName={JobNames.OEMbl} selectedElement={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Batch Print House B/L',
          level: 1,
          link: '/oceanExport/oemBatchPrint?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/oemBatchPrint/'),
          moreMenuJobName: JobNames.OEMbl
        },
        //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OEMbl, },
        //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.OEMbl },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OEMbl, },

        // { text: 'Agent Document Package', level: 1, popupComponent: <AgentDocumentPackage selectedElement={null} jobName={JobNames.OEMbl} />, moreMenuJobName: JobNames.OEMbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'Agent Document Package',
          level: 1,
          link: '/oceanExport/agentDocumentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/agentDocumentPackage/'),
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        // { text: 'Container Load Plan', level: 1, popupComponent: <ContainerLoadPlan selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Container Load Plan',
          level: 1,
          link: '/oceanExport/containerLoadPlan?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/containerLoadPlan'),
          moreMenuJobName: JobNames.OEMbl
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEMbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OEMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/folderLabel/'),
          moreMenuJobName: JobNames.OEMbl
        },
        { text: 'MBL/Shipping Request', level: 1, subMenu: FmsSubMenu.MasterSet, moreMenuJobName: JobNames.OEMbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OEMbl} />, popupLabel: 'Memo List (MBL)', moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoList/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Ocean Cargo Manifest', level: 1, popupComponent: <CargoManifest jobName={JobNames.OEMbl} selectedElement={null} />, moreMenuJobName: JobNames.OEMbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'Ocean Cargo Manifest',
          level: 1,
          link: '/oceanExport/cargoManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifest/'),
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        { text: 'Telex Release', level: 1, subMenu: FmsSubMenu.TelexReleaseMessage, moreMenuJobName: JobNames.OEMbl },
        //appcontext on off menu
        //{ text: 'Carrier Shipping Instruction', level: 1, moreMenuJobName: JobNames.OEMbl }, // <250205.dwshin. releated pims. remove menu.>
        //appcontext on off menu
        // { text: 'B/L EDI', level: 1, popupComponent: <SendBl jobName={JobNames.OEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'B/L EDI',
          level: 1,
          link: '/oceanExport/sendBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/sendBl/'),
          moreMenuJobName: JobNames.OEMbl
        },

        //Oeh More Menu
        {
          text: `AES Filing`,
          level: 1,
          name: 'aesFiling',
          iconImg: IconTypes.Shield,
          moreMenuJobName: JobNames.OEHbl,
          subMenu: FmsSubMenu.AesOcean,
        },
        { text: 'Booking Confirmation', level: 1, subMenu: FmsSubMenu.OOHBook, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/correctionNotice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Print House B/L', level: 1, popupComponent: <PrintHbl selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Print House B/L',
          level: 1,
          link: '/oceanExport/printHbl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/printHbl/'),
          moreMenuJobName: JobNames.OEHbl
        },
        //{ text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.OEHbl, },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.OEHbl, },
        // { text: 'Bank Draft', level: 1, popupComponent: <BankDraft jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'Bank Draft',
          level: 1,
          link: '/oceanExport/bankDraft?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/bankDraft/'),
          moreMenuJobName: JobNames.OEHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        { text: 'Certificate of Heat Treatment', level: 1, subMenu: FmsSubMenu.OEUSDA, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin selectedElementId={null} jobName={JobNames.OEHbl} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Certificate of Origin',
          level: 1,
          link: '/oceanExport/certificateOfOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/certificateOfOrigin/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Commercial Invoice', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptCommercialInvoice} tbName={getTbNameByJobName(JobNames.OEHbl)} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Commercial Invoice',
          level: 1,
          link: '/oceanExport/commercialInvoice?jobname=@jobName&id=@jobid&rptType=RPCOINV',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/commercialInvoice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Document Package', level: 1, popupComponent: <DocumentPackage jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Document Package',
          level: 1,
          link: '/oceanExport/documentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/documentPackage/'),
          moreMenuJobName: JobNames.OEHbl
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.OEHbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OEHbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/folderLabel/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/oceanExport/itTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/itTeNotice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OEHbl} />, popupLabel: 'Memo List (HBL)', moreMenuJobName: JobNames.OEHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/oceanExport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoCustomerList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/oceanExport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/packageLabel/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Packing List', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptPackingList} tbName={getTbNameByJobName(JobNames.OEHbl)} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Packing List',
          level: 1,
          link: '/oceanExport/packingList?jobname=@jobName&id=@jobid&rptType=RPPACKL',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/packingList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Shipping Advice',
          level: 1,
          link: '/oceanExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shippingAdvice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/oceanExport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/straightBl/'),
          moreMenuJobName: JobNames.OEHbl
        },

        //Booking More Menu
        {
          text: 'Booking Confirmation',
          level: 1,
          subMenu: FmsSubMenu.OOHBook,
          moreMenuJobName: JobNames.OEBook,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        // { text: 'Booking Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelBook} jobName={JobNames.OEBook} selectedElementId={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Booking Label',
          level: 1,
          link: '/oceanExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/airLabel/'),
          moreMenuJobName: JobNames.OEBook
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEBook },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEBook} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEBook
        },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.OEBook} selectedElement={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Shipping Advice',
          level: 1,
          link: '/oceanExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shippingAdvice/'),
          moreMenuJobName: JobNames.OEBook
        },

        //Download MBL More Menu
        // { text: 'Download MBL (All) List', level: 1, moreMenuJobName: JobNames.OEMPims },
        // { text: 'Download MBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OEMPims },
        // { text: 'Download MBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OEMPims },

        //Download HBL More Menu
        // { text: 'Download HBL (All) List', level: 1, moreMenuJobName: JobNames.OEHPims },
        // { text: 'Download HBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OEHPims },
        // { text: 'Download HBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OEHPims },
      
      ]
    },
    // Air Import
    {
      operation: constants.operations.airImport,
      job: [
        {
          text: 'Master AWB',
          level: 0,
          link: '/common/joblistview/aiMawb/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aiMawb/airImport'),
          fmsSecTask: FmsSecTask.AIMbl,
          moreMenuJobName: JobNames.AIMbl,
          secTaskGroup: constants.operations.airImport,
        },
        {
          text: 'House AWB',
          level: 0,
          link: '/common/joblistview/aiHawb/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aiHawb/airImport'),
          fmsSecTask: FmsSecTask.AIHbl,
          moreMenuJobName: JobNames.AIHbl,
          secTaskGroup: constants.operations.airImport,
        },
        {
          text: 'AI Quotation',
          level: 0,
          link: '/common/joblistview/aiQuotation/airImport?parentOp=airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aiQuotation/airImport'),
          fmsSecTask: FmsSecTask.AIQuot,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.airImport,
        },
        // {
        //   text: 'Invoice', level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'Bill', level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'CrDb', level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
          secTaskGroup: '',
        },
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
          secTaskGroup: '',
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          //textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          metadata: { isDirectPrint: true },
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: 'Pre Alert Report', level: 0,
          link: '/airImport/preAlert',
          fmsSecTask: FmsSecTask.AIRptPreAlert,
          topLineColor: borderColors[3 % borderColors.length],
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preAlert/'),
          secTaskGroup: constants.operations.airImport,
        },
        {
          text: 'Air Import Est. Profit Report', level: 1,
          link: '/airImport/estProfit?docType=705&isManagerReport=true&opType=airImport',
          fmsSecTask: FmsSecTask.AIRptEstProfit,
          topLineColor: borderColors[3 % borderColors.length],
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/estProfit'),
          secTaskGroup: constants.operations.airImport,
        },
        {
          text: 'Download MAWB',
          level: 0,
          link: '/common/joblistview/AIMP/airImport',
          topLineColor: borderColors[3 % borderColors.length],
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AIMP/airImport'),
          fmsSecTask: FmsSecTask.AIMPims,
          secTaskGroup: constants.operations.airImport,
        },
        {
          text: 'Download HAWB',
          level: 0,
          link: '/common/joblistview/AIHP/airImport',
          topLineColor: borderColors[3 % borderColors.length],
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AIHP/airImport'),
          fmsSecTask: FmsSecTask.AIHPims,
          secTaskGroup: constants.operations.airImport,
        },
      ],
      operationReport: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      moreMenu: [
        //Aim More Menu
        {
          text: 'Air Cargo Manifest',
          level: 1,
          subMenu: FmsSubMenu.AICargoManifest,
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/airImport/arrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/arrivalNotice/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Authority to Make Entry',
          level: 1,
          link: '/airImport/AuthorityToMakeEntry?jobname=@jobName&id=@jobid&isAtme=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/AuthorityToMakeEntry/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'IRC-225',
          level: 1,
          link: '/airImport/IRC225?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/IRC225/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/correctionNotice/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AIMbl, },
        //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AIMbl },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AIMbl, },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AIMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/airImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/folderLabel/'),
          moreMenuJobName: JobNames.AIMbl
        },
        //{ text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AIMbl} />, popupLabel: 'Memo List (MAWB)', moreMenuJobName: JobNames.AIMbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/airImport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.AIMbl} />, moreMenuJobName: JobNames.AIMbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          //textColor: 'orangered',
          link: '/airImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.AIMbl,
          //topLineColor: borderColors[3 % borderColors.length],
          iconImg: IconTypes.Shield,
        },
        //Aih More Menu
        //{ text: 'Arrival Notice', level: 1, popupComponent: <HblArrivalNotice selectedElement={null} jobName={JobNames.AIHbl} />, popupLabel: 'Arrival Notice (HAWB)', topLineColor: borderColors[0 % borderColors.length],moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/airImport/hblArrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/hblArrivalNotice/'),
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Arrival Notice',
          level: 1,
          moreMenuJobName: JobNames.AIHbl,
          subMenu: FmsSubMenu.ArrivalNotice
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        { text: 'Authority to Make Entry', level: 1, subMenu: FmsSubMenu.AuthEntry, moreMenuJobName: JobNames.AIHbl },
        //{ text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/correctionNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Delivery Order (Pre Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={null} docType={DocumentType.DO} />, moreMenuJobName: JobNames.AIHbl },
        // {
        //   text: 'Delivery Order (Pre Form)',
        //   level: 1,
        //   link: '/airImport/preDeliveryOrder?jobname=@jobName&id=@jobid&docType=59',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preDeliveryOrder/'),
        //   moreMenuJobName: JobNames.AIHbl,
        // },
        //{ text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Delivery Order',
          level: 1,
          link: '/airImport/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AIHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AIHbl, },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AIHbl, },
        {
          text: 'Carrier\'s Certificate',
          level: 1,
          subMenu: FmsSubMenu.CarrierCertificate,
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.AIHbl },
        //{ text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.AIHbl} selectedElement={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/airImport/ItTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/ItTeNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AIHbl} />, popupLabel: 'Memo List (HAWB)', moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/airImport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/memoList/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/airImport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/memoCustomerList/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/airImport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/packageLabel/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Preliminary Claim Notice', level: 1, popupComponent: <PreliminaryClaimNotice jobName={JobNames.AIHbl} selectedElement={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Preliminary Claim Notice',
          level: 1,
          link: '/airImport/preliminaryClaimNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preliminaryClaimNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Proof of Delivery', level: 1, popupComponent: <ProofOfDelivery selectedElement={null} jobName={JobNames.AIHbl} />, popupWidth: 790, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Proof of Delivery',
          level: 1,
          link: '/airImport/proofOfDelivery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/proofOfDelivery/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Release Order/Turnover', level: 1, popupComponent: <ReleaseOrderTurnover jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl  },
        {
          text: 'Release Order/Turnover',
          level: 1,
          link: '/airImport/releaseOrderTurnover?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/releaseOrderTurnover/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/airImport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/straightBl/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.AIHbl} />, moreMenuJobName: JobNames.AIHbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          //textColor: 'orangered',
          link: '/airImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[3 % borderColors.length],
          iconImg: IconTypes.Shield,
        },
        //Download MAWB More Menu
        // { text: 'Download MAWB (All) List', level: 1, moreMenuJobName: JobNames.AIMPims },
        // { text: 'Download MAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AIMPims },
        // { text: 'Download MAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AIMPims },

        //Download HAWB More Menu
        // { text: 'Download HAWB (All) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        // { text: 'Download HAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        // { text: 'Download HAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        {
          text: 'Print HAWB',
          level: 1,
          subMenu: FmsSubMenu.AIAWB,
          moreMenuJobName: JobNames.AIHbl,
        },
      ]
    },
    // Air Export
    {
      operation: constants.operations.airExport,
      job: [
        {
          text: 'AE Quotation', level: 0,
          link: '/common/joblistview/aeQuotation/airExport?parentOp=airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeQuotation/airExport'),
          fmsSecTask: FmsSecTask.AEQuot,
          secTaskGroup: constants.operations.airExport,
        },
        {
          text: 'Master AWB',
          level: 0,
          link: '/common/joblistview/aeMawb/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeMawb/airExport'),
          fmsSecTask: FmsSecTask.AEMbl,
          moreMenuJobName: JobNames.AEMbl,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.airExport,
        },
        {
          text: 'House AWB',
          level: 0,
          link: '/common/joblistview/aeHawb/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeHawb/airExport'),
          fmsSecTask: FmsSecTask.AEHbl,
          moreMenuJobName: JobNames.AEHbl,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.airExport,
        },
        // {
        //   text: 'Invoice', level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'Bill', level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'CrDb', level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
          secTaskGroup: '',
        },
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
          secTaskGroup: '',
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          //textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          metadata: { isDirectPrint: true },
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: 'Air Export Est. Profit Report', level: 1,
          topLineColor: borderColors[3 % borderColors.length],
          link: '/airExport/estProfit?docType=705&isManagerReport=true&opType=airExport',
          fmsSecTask: FmsSecTask.AERptEstProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/estProfit'),
          secTaskGroup: constants.operations.airExport,
        },
        {
          text: 'Download MAWB',
          level: 0,
          topLineColor: borderColors[3 % borderColors.length],
          link: '/common/joblistview/AEMP/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AEMP/airExport'),
          fmsSecTask: FmsSecTask.AEMPims,
          secTaskGroup: constants.operations.airExport,
        },
        {
          text: 'Download HAWB',
          level: 0,
          topLineColor: borderColors[3 % borderColors.length],
          link: '/common/joblistview/AEHP/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AEHP/airExport'),
          fmsSecTask: FmsSecTask.AEHPims,
          secTaskGroup: constants.operations.airExport,
        },
      ],
      operationReport: [],
      report: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      moreMenu: [
        { text: 'Transmit e-AWB', level: 1, name: 'eawb', moreMenuJobName: JobNames.AEMbl, link: '/airExport/eawb?jobname=@jobName&id=@jobid', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/eawb') },
        { text: 'Transmit e-AWB', level: 1, name: 'eawb', moreMenuJobName: JobNames.AEHbl, link: '/airExport/eawb?jobname=@jobName&id=@jobid', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/eawb') },
        //Aem More Menu
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/correctionNotice/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pickupDelivery/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Print MAWB',
          level: 1,
          link: '/airExport/aemPrintMawb?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemPrintMawb/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Batch Print HAWB',
          level: 1,
          link: '/airExport/aemBatchPrint?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemBatchPrint/'),
          moreMenuJobName: JobNames.AEMbl,
        },
        //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AEMbl, },
        //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AEMbl },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AEMbl, },
        {
          text: 'Agent Document Package',
          level: 1,
          link: '/airExport/agentDocument?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/agentDocument/'),
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[2 % borderColors.length] 
        }, {
          text: 'Air Cargo Manifest',
          level: 1,
          link: '/airExport/cargoManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/cargoManifest/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Air Label',
          level: 1,
          link: '/airExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/airLabel/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Pouch Air Label',
          level: 1,
          link: '/airExport/pouchAirLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pouchAirLabel/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Certificate of Origin',
          level: 1,
          link: '/airExport/certificationOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/certificationOrigin/'),
          moreMenuJobName: JobNames.AEMbl,
        },
        { text: 'IAC Certificate (Known)',
          level: 1,
          //subMenu: FmsSubMenu.TsaSecurity,
          moreMenuJobName: JobNames.AEMbl, 
          link: '/airExport/iacCertificateKnown?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/iacCertificateKnown/'),
        },
        { text: 'IAC Certificate (Unknown)',
          level: 1,
          //subMenu: FmsSubMenu.TsaUnknown,
          moreMenuJobName: JobNames.AEMbl,
          link: '/airExport/iacCertificateUnknown?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/iacCertificateUnknown/'),
        },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AEMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/airExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/folderLabel/'),
          moreMenuJobName: JobNames.AEMbl
        },
        {
          text: 'Memo List',
          level: 1,
          link: '/airExport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoList/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Shipping Advice',
          level: 1,
          link: '/airExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/shippingAdvice/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Transfer Manifest',
          level: 1,
          link: '/airExport/transferManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/transferManifest/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Send B/L to Partner',
          level: 1,
          link: '/airExport/sendBLtoPatner?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/sendBLtoPatner/'),
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[3 % borderColors.length] 
        },

        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AEMbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Print MAWB', level: 1, popupComponent: <Print jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Batch Print HAWB', level: 1, popupComponent: <BatchPrint selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[1 % borderColors.length] },
        // //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Agent Document Package', level: 1, popupComponent: <AgentDocumentPackage jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[2 % borderColors.length] },
        // { text: 'Air Cargo Manifest', level: 1, popupComponent: <CargoManifest jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Air Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelAir} selectedElementId={null} jobName={JobNames.AEMbl} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Pouch Air Label', level: 1, popupComponent: <PouchAirLabel selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin selectedElementId={null} jobName={JobNames.AEMbl} />, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'IAC Certificate (Known)', level: 1, subMenu: FmsSubMenu.TsaSecurity, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'IAC Certificate (Unknown)', level: 1, subMenu: FmsSubMenu.TsaUnknown, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AEMbl} />, popupLabel: 'Memo List (MAWB)', moreMenuJobName: JobNames.AEMbl },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Send B/L to Partner', level: 1, popupComponent: <SendBl jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[3 % borderColors.length] },

        //Aeh More Menu
        {
          text: `AES Filing`,
          level: 1,
          name: 'aesFiling',
          iconImg: IconTypes.Shield,
          moreMenuJobName: JobNames.AEHbl,
          subMenu: FmsSubMenu.AesAir
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/correctionNotice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pickupDelivery/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Print HAWB',
          level: 1,
          link: '/airExport/aemPrintHawb?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemPrintHawb/'),
          moreMenuJobName: JobNames.AEHbl,
        },
        //{ text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AEHbl, },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AEHbl, },
        {
          text: 'Air Label',
          level: 1,
          link: '/airExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/airLabel/'),
          moreMenuJobName: JobNames.AEHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        }, {
          text: 'Bank Draft',
          level: 1,
          link: '/airExport/bankDraft?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/bankDraft/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Certificate of Origin',
          level: 1,
          link: '/airExport/certificationOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/certificationOrigin/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Document Package',
          level: 1,
          link: '/airExport/documentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/documentPackage/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Commercial Invoice',
          level: 1,
          link: '/airExport/commercialInvoice?jobname=@jobName&id=@jobid&rptType=RPCOINV',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/commercialInvoice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Memo List',
          level: 1,
          link: '/airExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/airExport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoCustomerList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Package Label',
          level: 1,
          link: '/airExport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/packageLabel/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Packing List',
          level: 1,
          link: '/airExport/packingList?jobname=@jobName&id=@jobid&rptType=RPPACKL',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/packingList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Shipping Advice',
          level: 1,
          link: '/airExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/shippingAdvice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Straight B/L',
          level: 1,
          link: '/airExport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/straightBl/'),
          moreMenuJobName: JobNames.AEHbl,
        },

        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AEHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Print HAWB', level: 1, popupComponent: <Print jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AEHbl, topLineColor: borderColors[1 % borderColors.length] },
        // { text: 'Air Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelAir} jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl, topLineColor: borderColors[2 % borderColors.length] },
        // { text: 'Bank Draft', level: 1, popupComponent: <BankDraft jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Document Package', level: 1, popupComponent: <DocumentPackage jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Commercial Invoice', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptCommercialInvoice} tbName={getTbNameByJobName(JobNames.AEHbl)} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AEHbl} />, popupLabel: 'Memo List (HAWB)', moreMenuJobName: JobNames.AEHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.AEHbl },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Packing List', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptPackingList} tbName={getTbNameByJobName(JobNames.AEHbl)} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },

        //Download MAWB More Menu
        // { text: 'Download MAWB (All) List', level: 1, moreMenuJobName: JobNames.AEMPims },
        // { text: 'Download MAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AEMPims },
        // { text: 'Download MAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AEMPims },

        //Download HAWB More Menu
        // { text: 'Download HAWB (All) List', level: 1, moreMenuJobName: JobNames.AEHPims },
        // { text: 'Download HAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AEHPims },
        // { text: 'Download HAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AEHPims },
      ]
    },
    // Other Shipment
    {
      operation: constants.operations.otherShipment,
      job: [
        {
          text: 'Other Shipment List', level: 0,
          link: '/common/joblistview/otherShipment/otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/otherShipment/otherShipment'),
          fmsSecTask: FmsSecTask.OtherOP,
          moreMenuJobName: JobNames.OtherOP,
          secTaskGroup: constants.operations.otherShipment,
        },
        {
          text: 'Container List (OT)', level: 0,
          link: '/common/joblistview/OTOPC/otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OTOPC/otherShipment'),
          fmsSecTask: FmsSecTask.OtherOP,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.otherShipment,
        },
        {
          text: 'Quotation', level: 0,
          //link: '/common/joblistview/otQuotation/otherShipment',
          link: '/common/joblistview/otQuotation/otherShipment?parentOp=otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/otQuotation/otherShipment'),
          fmsSecTask: FmsSecTask.OTQuot,
          topLineColor: borderColors[0 % borderColors.length],
          secTaskGroup: constants.operations.otherShipment,
        },
        // {
        //   text: 'Invoice', level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'Bill', level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        // {
        //   text: 'CrDb', level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   topLineColor: borderColors[1 % borderColors.length],
        //   secTaskGroup: '',
        // },
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4',
          secTaskGroup: '',
        },
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
          secTaskGroup: '',
        },
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
          secTaskGroup: '',
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          //textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          metadata: { isDirectPrint: true },
          topLineColor: borderColors[2 % borderColors.length],
          iconImg: IconTypes.Shield,
          secTaskGroup: '',
        },
        // {
        //   text: 'Freight Receipt', level: 0,
        //   link: '/common/joblistview/whReceipt/otherShipment',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceipt/otherShipment'),
        //   fmsSecTask: FmsSecTask.WHRcpt
        // },
      ],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [
        // {
        //   text: 'Report', level: 0,
        //   items: [
        //     // {text: 'Invoice List', level: 1},
        //     // {text: 'Bill List', level: 1},
        //     // {text: 'CrDb List', level: 1},
        //     {text: 'Volume Report', level: 1, popupComponent: <VolumeReportDetails opType={'otherShipment'} /> },
        //     {text: 'Issue Ready Invoice Report', level: 1},
        //     {text: 'Issue Ready Bill Report', level: 1},
        //     {text: 'Issue Ready Cr/Db Report', level: 1},
        //   ]
        // },
      ],
      moreMenu: [
        //Other Shipment More Menu
        {
          text: 'Delivery Order',
          level: 1,
          link: '/otherShipment/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OtherOP} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, popupWidth: 760, moreMenuJobName: JobNames.OtherOP, topLineColor: borderColors[0 % borderColors.length]  },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/otherShipment/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/pickupDelivery/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OtherOP} docType={DocumentType.Pickup} selectedElementId={null} />, popupWidth:760, moreMenuJobName: JobNames.OtherOP },
        //{ text: 'Est. Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OtherOP, },
        //{ text: 'Gross Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.OtherOP },
        { text: 'Profit Report', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.OtherOP, },
        // {
        //   text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel,
        //   moreMenuJobName: JobNames.OtherOP,
        //   //topLineColor: borderColors[2 % borderColors.length],
        //   metadata: { isDirectPrint: true }
        // },            
        {
          text: 'Folder Label',
          level: 1,
          link: '/otherShipment/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/folderLabel/'),
          moreMenuJobName: JobNames.OtherOP
        },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/otherShipment/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/straightBl/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OtherOP} selectedElementId={null} />, popupWidth:760, moreMenuJobName: JobNames.OtherOP },
        {
          text: 'CBP Status Query',
          level: 1,
          //textColor: 'orangered',
          link: '/otherShipment/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OtherOP,
          //topLineColor: borderColors[3 % borderColors.length],
          iconImg: IconTypes.Shield,
        },
        {
          text: `AES Filing`,
          level: 1,
          name: 'aesFiling',
          iconImg: IconTypes.Shield,
          moreMenuJobName: JobNames.OtherOP,
          subMenu: FmsSubMenu.AesOtherOP,
        },
      ]
    },

    //Change name W/H Receipt -> Freight Receipt
    //Other Shipment Side Menu -> Main Menu
    //Freight Receipt
    {
      operation: constants.operations.whReceipt,
      job: [
        {
          text: 'Freight Receipt List', level: 0,
          link: '/common/joblistview/whReceipt/whReceipt',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceipt/whReceipt'),
          fmsSecTask: FmsSecTask.WHRcpt,
          moreMenuJobName: JobNames.WHRcpt,
        }
      ],
      preReport: [],
      report: [],
      moreMenu: [
        //Freight Receipt More Menu
        { text: 'Freight Arrival Notice', level: 1, subMenu: FmsSubMenu.FArrivalNotice, moreMenuJobName: JobNames.WHRcpt },
        {
          text: 'Freight Receipt Label',
          level: 1,
          link: '/warehousing/receiptLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/receiptLabel/'),
          moreMenuJobName: JobNames.WHRcpt
        },
        {
          text: 'Received Cargo Status',
          level: 1,
          link: '/warehousing/receivedcargostatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/receivedcargostatus/'),
          moreMenuJobName: JobNames.WHRcpt
        },
      ]
    },
    // Warehousing
    {
      operation: constants.operations.warehousing,
      job: [
        {
          text: 'Receiving', level: 0,
          link: '/common/joblistview/whReceiving/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceiving/warehousing'),
          fmsSecTask: FmsSecTask.WHRcv,
          moreMenuJobName: JobNames.WHRcv,
        },
        {
          text: 'Shipping', level: 0,
          link: '/common/joblistview/whShipping/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whShipping/warehousing'),
          fmsSecTask: FmsSecTask.WHShip,
          moreMenuJobName: JobNames.WHShip,
        },
        {
          text: 'Inventory', level: 0,
          link: '/common/joblistview/whInventory/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whInventory/warehousing'),
          fmsSecTask: FmsSecTask.WHInvenSummary,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'In/Out Activity', level: 0,
          link: '/common/joblistview/whInOut/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whInOut/warehousing'),
          fmsSecTask: FmsSecTask.WHInvenDetail,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Invoice (WH)', level: 0,
          link: '/common/joblistview/invoice/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/warehousing'),
          fmsSecTask: FmsSecTask.WHInvoice,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Bill (WH)', level: 0,
          link: '/common/joblistview/bill/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/warehousing'),
          fmsSecTask: FmsSecTask.WHBill,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'CrDb (WH)', level: 0,
          link: '/common/joblistview/crdb/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/warehousing'),
          fmsSecTask: FmsSecTask.WHCrDb,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Storage Invoice', level: 0,
          link: '/common/joblistview/whStorageInvoice/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whStorageInvoice/warehousing'),
          fmsSecTask: FmsSecTask.WHStorageInv,
          topLineColor: borderColors[1 % borderColors.length]
        },
        // ↓ 선택된 Invoice / Bill / CrDb / Storage Invoice (WH) 의 컨텍스트 메뉴(View History, Print, Batch Print ...)가 이 자리에 들어간다 (IfmsMain)
        { text: 'More Menu Slot', level: 0, metadata: { moreMenuSlot: true } },
        {
          text: 'Customer (WH)', level: 0,
          link: '/common/joblistview/whCompany/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whCompany/warehousing'),
          fmsSecTask: FmsSecTask.WHCustomer,
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: 'Item (WH)', level: 0,
          link: '/common/joblistview/whItem/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whItem/warehousing'),
          fmsSecTask: FmsSecTask.WHItem,
          topLineColor: borderColors[2 % borderColors.length],
        },
        {
          text: 'Location (WH)', level: 0,
          link: '/common/joblistview/whLocation/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whLocation/warehousing'),
          fmsSecTask: FmsSecTask.WHLoc,
          topLineColor: borderColors[2 % borderColors.length],
        },
        {
          text: 'Chargeable Item Report', level: 0,
          link: '/warehousing/chargeItemSummary?jobname=@jobName&id=@jobid&docType=101',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/chargeItemSummary/'),
          fmsSecTask: FmsSecTask.WHRptChargeItemSummary,
          topLineColor: borderColors[3 % borderColors.length]
        },
        {
          text: 'Customer In/Out Report', level: 0,
          link: '/warehousing/CustomerInNOut?jobname=@jobName&id=@jobid&docType=186',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/customerInNOut'),
          fmsSecTask: FmsSecTask.WHRptCustomerInNOut,
          topLineColor: borderColors[3 % borderColors.length]
        },
        // // Customer Pay List  ------------------------
        // {
        //   text: 'Customer Pay List',
        //   level: 0,
        //   subMenuNonReport: FmsSubMenu.CustomerPayList,
        //   fmsSecTask: FmsSecTask.AcctCustPayment,
        //   topLineColor: '#ffc000',
        //   topLineShort: true,
        // },
        // // Bill Pay List  -----------------------------
        // {
        //   text: 'Bill Pay List',
        //   level: 0,
        //   subMenuNonReport: FmsSubMenu.BillPayList,
        //   fmsSecTask: FmsSecTask.AcctBillPayment,
        // },
        // {
        //   text: 'Customer (WH)', level: 0,
        //   link: '/common/joblistview/whCompany/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whCompany/warehousing'),
        //   fmsSecTask: FmsSecTask.WHCustomer,
        //   topLineColor: borderColors[2 % borderColors.length]
        // },
        // {
        //   text: 'Item (WH)', level: 0,
        //   link: '/common/joblistview/whItem/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whItem/warehousing'),
        //   fmsSecTask: FmsSecTask.WHItem,
        //   topLineColor: borderColors[2 % borderColors.length],
        // },
        // {
        //   text: 'Location (WH)', level: 0,
        //   link: '/common/joblistview/whLocation/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whLocation/warehousing'),
        //   fmsSecTask: FmsSecTask.WHLoc,
        //   topLineColor: borderColors[2 % borderColors.length],
        // },
        // {
        //   text: 'Chargeable Item Report', level: 0,
        //   link: '/warehousing/chargeItemSummary?jobname=@jobName&id=@jobid&docType=101',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/chargeItemSummary/'),
        //   fmsSecTask: FmsSecTask.WHRptChargeItemSummary,
        //   topLineColor: borderColors[3 % borderColors.length]
        // },
        // {
        //   text: 'Customer In/Out Report', level: 0,
        //   link: '/warehousing/CustomerInNOut?jobname=@jobName&id=@jobid&docType=186',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/customerInNOut'),
        //   fmsSecTask: FmsSecTask.WHRptCustomerInNOut,
        //   topLineColor: borderColors[3 % borderColors.length]
        // },

        // {
        //   text: 'Company (WH)', level: 0,
        //   link: '/common/joblistview/whCompany/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whCompany/warehousing'),
        // },
        // {
        //   text: 'Item (WH)', level: 0,
        //   link: '/common/joblistview/whItem/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whItem/warehousing'),
        // },
        // {
        //   text: 'Location (WH)', level: 0,
        //   link: '/common/joblistview/whLocation/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whLocation/warehousing'),
        // },
      ],
      report: [],
      operationReport: [],
      moreMenu: [
        {
          text: 'View History',
          level: 1,
          moreMenuJobName: JobNames.WHStorageInv,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        {
          text: 'View History',
          level: 1,
          moreMenuJobName: JobNames.WHInvoice,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        {
          text: 'View History',
          level: 1,
          moreMenuJobName: JobNames.WHBill,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        {
          text: 'View History',
          level: 1,
          moreMenuJobName: JobNames.WHCrDb,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        // Delete History  -----------------------------
        {
          text: 'Delete History',
          level: 1,
          moreMenuJobName: JobNames.WHInvoice,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid&operation=Warehouse',
          isSelected: (p: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          level: 1,
          moreMenuJobName: JobNames.WHStorageInv,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid&operation=Warehouse',
          isSelected: (p: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          level: 1,
          moreMenuJobName: JobNames.WHBill,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid&operation=Warehouse',
          isSelected: (p: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          level: 1,
          moreMenuJobName: JobNames.WHCrDb,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid&operation=Warehouse',
          isSelected: (p: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        // Print  -----------------------------
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.WHInvoice,
          subMenu: FmsSubMenu.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#ffc001',
          topLineShort: true,
        },
        {
          text: 'Print',
          level: 1,
          subMenu: FmsSubMenu.Invoice,
          moreMenuJobName: JobNames.WHStorageInv,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#ffc001',
          topLineShort: true,
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.WHBill,
          fmsSecTask: FmsSecTask.AcctBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          topLineColor: '#ffc001',
          topLineShort: true,
        },
        {
          text: 'Print',
          level: 1,
          subMenu: FmsSubMenu.CrDbNote,
          moreMenuJobName: JobNames.WHCrDb,
          fmsSecTask: FmsSecTask.AcctCrDbList,
          topLineColor: '#ffc001',
          topLineShort: true,
        },
        // ===== WH Invoice =====
        {
          text: 'Batch Print',
          level: 1,
          moreMenuJobName: JobNames.WHInvoice,
          fmsSecTask: FmsSecTask.WHInvoice,
          link: `/accounting/batchPrint/invoice/add?parentOp=warehousing`,
          secTaskGroup: constants.operations.accounting,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/batchPrint/invoice/add'),
        },
        {
          text: 'Batch Print History',
          level: 1,
          moreMenuJobName: JobNames.WHInvoice,
          fmsSecTask: FmsSecTask.WHInvoice,
          link: `/common/joblistview/acBatchPrintHistory/accounting?parentOp=warehousing`,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchPrintHistory/accounting'),
          secTaskGroup: constants.operations.accounting,
        },
        // ===== WH Storage Invoice =====
        {
          text: 'Batch Print',
          level: 1,
          moreMenuJobName: JobNames.WHStorageInv,
          fmsSecTask: FmsSecTask.WHStorageInv,
          link: `/accounting/batchPrint/invoice/add?parentOp=warehousing`,
          secTaskGroup: constants.operations.accounting,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/batchPrint/invoice/add'),
        },
        {
          text: 'Batch Print History',
          level: 1,
          moreMenuJobName: JobNames.WHStorageInv,
          fmsSecTask: FmsSecTask.WHStorageInv,
          link: `/common/joblistview/acBatchPrintHistory/accounting?parentOp=warehousing`,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchPrintHistory/accounting'),
          secTaskGroup: constants.operations.accounting,
        },
        // {
        //   text: 'Batch Print',
        //   level: 1,
        //   moreMenuJobName: JobNames.WHCrDb,
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        //   subMenuNonReport: FmsSubMenu.BatchPrint,
        // },
        // {
        //   text: 'Customer Pay List',
        //   level: 0,
        //   subMenuNonReport: FmsSubMenu.CustomerPayList,
        //   fmsSecTask: FmsSecTask.AcctCustPayment,
        //   topLineColor: '#ffc002',
        //   topLineShort: true,
        // },
        // {
        //   text: 'Bill Pay List',
        //   level: 0,
        //   subMenuNonReport: FmsSubMenu.BillPayList,
        //   fmsSecTask: FmsSecTask.AcctBillPayment,
        // },

        //Receiving More Menu
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/warehousing/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/pickupDelivery/'),
          moreMenuJobName: JobNames.WHRcv,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.WHRcv} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.WHRcv, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/warehousing/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/straightBl/'),
          moreMenuJobName: JobNames.WHRcv,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.WHRcv} selectedElementId={null} />, moreMenuJobName: JobNames.WHRcv },
        { text: 'Warehouse Receipt', level: 1, subMenu: FmsSubMenu.WReceipt, moreMenuJobName: JobNames.WHRcv },
        { text: 'Warehouse Receiving Label', level: 1, subMenu: FmsSubMenu.WLabelReceive, moreMenuJobName: JobNames.WHRcv },

        //Shipping More Menu
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/warehousing/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/pickupDelivery/'),
          moreMenuJobName: JobNames.WHShip,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.WHShip} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.WHShip, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/warehousing/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/straightBl/'),
          moreMenuJobName: JobNames.WHShip,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.WHShip} selectedElementId={null} />, moreMenuJobName: JobNames.WHShip },
        { text: 'Pickup Slip', level: 1, subMenu: FmsSubMenu.WShip, moreMenuJobName: JobNames.WHShip },
        { text: 'Warehouse Shipping Label', level: 1, subMenu: FmsSubMenu.WLabelShip, moreMenuJobName: JobNames.WHShip },
      ]
    },

    {
      operation: constants.operations.accounting,
      job: [
        {
          text: 'Bank Balance',
          level: 0,
          link: '/accounting/acBankBalanceView',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acBankBalanceView'),
          fmsSecTask: FmsSecTask.AcctBankBalance,
          topLineColor: '#d9d9d9',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Bank Recon',
          level: 0,
          link: '/common/joblistview/acBankRecon/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankRecon/accounting'),
          fmsSecTask: FmsSecTask.AcctBankRecon,
          topLineColor: '#d9d9d9',
          secTaskGroup: constants.operations.accounting,
        },
        { // 250805.inhyung.issue#2641 Bank Transfer 그룹 변경
          text: 'Bank Transfer',
          level: 0,
          link: '/common/joblistview/acBankTransfer/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankTransfer/accounting'),
          fmsSecTask: FmsSecTask.AcctBankTransfer,
          topLineColor: '#d9d9d9',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Daily Accounting Summary',
          level: 0,
          link: '/accounting/acDailyAccountingSummary',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDailyAccountingSummary'),
          fmsSecTask: FmsSecTask.AcctDailyAcctSummary,
          topLineColor: '#d9d9d9',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Payment List',
          level: 0,
          link: '/common/joblistview/acAllPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAllPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctAllPayment,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Customer Pay',
          level: 0,
          link: '/common/joblistview/acCustomerPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,          
        },
        {
          text: 'Bill Pay',
          level: 0,
          link: '/common/joblistview/acBillPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBillPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'CC Pay',
          level: 0,
          link: '/common/joblistview/acCCPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCCPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctCCPayment,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Agent Settlement (Old)',
          level: 0,
          link: '/common/joblistview/acAgentPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAgentPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctAgntPayment,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,
        },
        // {
        //   text: 'Payment Prep',
        //   level: 0,
        //   link: '/common/joblistview/acPaymentPrep/accounting',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPaymentPrep/accounting'),
        //   fmsSecTask: FmsSecTask.AcctPaymentPrep,
        // },
        {
          text: 'Deposit / Check Clear',
          level: 0,
          link: '/accounting/acDepositCheckClear',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDepositCheckClear'),
          fmsSecTask: FmsSecTask.AcctDeposit,
          topLineColor: '#d9d9db',
          secTaskGroup: constants.operations.accounting,          
        },
        {
          text: 'Undo Deposit / Cancel Check',
          level: 0,
          link: '/accounting/acUndoDepositCheckClear',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acUndoDepositCheckClear'),
          fmsSecTask: FmsSecTask.AcctUndoDeposit,
          topLineColor: '#d9d9db',
          secTaskGroup: constants.operations.accounting,          
        },
        // {
        //   text: 'Credit Card Clear',
        //   level: 0,
        //   // link: '/common/joblistview/acCreditCardClear/accounting',
        //   // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
        //   // popupComponent: <CreditCardClearView mode={FormType.ModeAdd} />,
        //   // popupWidth: 840,
        //   // popupTop: 50, 
        //   link: '/accounting/acCreditCardClear',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCreditCardClear'),
        //   fmsSecTask: FmsSecTask.AcctCCClear,
        //   topLineColor: '#d9d9db',
        // },
        // {
        //   text: 'Cancel Credit Card Clear',
        //   level: 0,
        //   // link: '/common/joblistview/acCreditCardClear/accounting',
        //   // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
        //   // popupComponent: <CancelCreditCardClearView mode={FormType.ModeAdd} />,
        //   // popupWidth: 840,
        //   // popupTop: 50, 
        //   link: '/accounting/acCancelCreditCardClear',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCancelCreditCardClear'),
        //   fmsSecTask: FmsSecTask.AcctCancelCCClear,
        //   topLineColor: '#d9d9db',
        // },
        {
          text: 'Check Clear with Excel',
          level: 0,
          link: '/accounting/acCheckClearwExcel',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCheckClearwExcel'),
          fmsSecTask: FmsSecTask.AcctChkClearWithExcel,
          topLineColor: '#d9d9db',
          secTaskGroup: constants.operations.accounting,          
        },
        // {
        //   text: 'Aging',
        //   level: 0,
        //   popupComponent: <AgingReportDetails initialAgingOption={AgingReportEnum.AR_AGING} />,
        //   popupWidth: 760,
        //   fmsSecTask: FmsSecTask.AcctAging,
        //   topLineColor: '#d9d9d9'
        // },
        {
          text: 'Aging',
          level: 0,
          link: '/accounting/acAging',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAging'),
          fmsSecTask: FmsSecTask.AcctAging,
          topLineColor: '#d9dad9',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Customer Statement',
          level: 0,
          // popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType={''} />,
          // popupWidth: 760,
          // popupTop: 50,
          link: '/accounting/acCustomerStatement?parentOp=accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCustomerStatement'),
          fmsSecTask: FmsSecTask.AcctCustStatement,
          topLineColor: '#d9dad9',
          secTaskGroup: constants.operations.accounting,          
        },
        {
          text: 'Agent Statement',
          level: 0,
          link: '/accounting/acAgentStatement?parentOp=accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAgentStatement'),
          fmsSecTask: FmsSecTask.AcctAgentStatement,
          topLineColor: '#d9dad9',
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Customer Pay Memo',
          level: 0,
          link: '/common/joblistview/acCustomerPaymentMemo/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPaymentMemo/accounting'),
          fmsSecTask: FmsSecTask.AcctCustPaymentMemo,
          topLineColor: '#d9dad9',
          secTaskGroup: constants.operations.accounting,          
        },

        {
          text: 'Invoice',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#dad9d9',
          secTaskGroup: '',
        },
        {
          text: 'Bill',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList,
          topLineColor: '#dad9d9',
          secTaskGroup: '',          
        },
        {
          text: 'CrDb',
          level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList,
          topLineColor: '#dad9d9',
          secTaskGroup: '',          
        },
        {
          text: 'G. Bill',
          level: 0,
          link: '/common/joblistview/acGeneralBill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralBill/accounting'),
          fmsSecTask: FmsSecTask.AcctGBillList,
          topLineColor: '#dad9d9',
          secTaskGroup: '',          
        },
        {
          text: 'G. Invoice',
          level: 0,
          link: '/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralInvoice/accounting'),
          fmsSecTask: FmsSecTask.AcctGInvoList,
          topLineColor: '#dad9d9',
          secTaskGroup: '',          
        },
        {
          text: 'Payroll (Old)',
          level: 0,
          link: '/common/joblistview/acPayrollSummary/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPayrollSummary/accounting'),
          fmsSecTask: FmsSecTask.AcctPayroll,
          topLineColor: '#d9dad8',
          secTaskGroup: constants.operations.accounting,              
        },
        {
          text: 'Payroll',
          level: 0,
          link: '/common/joblistview/acPayroll2/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPayroll2/accounting'),
          fmsSecTask: FmsSecTask.AcctPayroll,
          topLineColor: '#d9dad8',
          secTaskGroup: constants.operations.accounting,               
        },
        {
          text: 'Sales / Cost Batch Recog',
          level: 0,
          topLineColor: '#d9dad8',
          items: [
            {
              text: 'Sales / Cost Batch Recog',
              level: 1,
              link: '/accounting/acSalesCostRecog/add',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acSalesCostRecog/add'),
              fmsSecTask: FmsSecTask.SCRecogBatchRecog,
              topLineColor: '#d8d9d9',
              secTaskGroup: constants.operations.accounting,                   
            },
            {
              text: 'Batch Recog History',
              level: 1,
              link: '/common/joblistview/acBatchRecogHistory/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchRecogHistory/accounting'),
              fmsSecTask: FmsSecTask.SCRecogBatchRecogHistory,
              topLineColor: '#d8d9d9',
              secTaskGroup: constants.operations.accounting,                   
            },
          ],
          nonItemThenHide:true
        },
        {
          text: 'Deferred Report',
          level: 0,
          link: '/accounting/acDeferredReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDeferredReport'),
          fmsSecTask: FmsSecTask.SCRecogDeferred,
          topLineColor: '#d9dad8',
          secTaskGroup: constants.operations.accounting,               
        },
        {
          text: 'Account Balance',
          level: 0,
          link: '/accounting/acAccountBalance',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAccountBalance'),
          fmsSecTask: FmsSecTask.AcctBalByEntity,
          topLineColor: '#d9d8d9',
          secTaskGroup: constants.operations.accounting,     
        },
        {
          text: 'Account Ledger',
          level: 0,
          link: '/accounting/acAccountLedger',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAccountLedger'),
          fmsSecTask: FmsSecTask.AcctLedger,
          topLineColor: '#d9d8d9',
          secTaskGroup: constants.operations.accounting,               
        },
        {
          text: 'General Ledger',
          level: 0,
          link: '/accounting/acGeneralLedger',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acGeneralLedger'),
          fmsSecTask: FmsSecTask.AcctGeneralLedger,
          topLineColor: '#d9d8d9',
          secTaskGroup: constants.operations.accounting,               
        },
        {
          text: 'Accounting Classify',
          level: 0,
          topLineColor: '#dadada',
          secTaskGroup: constants.operations.accounting,               
          items: [
            {
              text: 'Prepaid Expense', level: 1,
              link: '/common/joblistview/acPrepaidExpenseAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPrepaidExpenseAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctPrepaidAdjustment,
  
              secTaskGroup: constants.operations.accounting,     
            },
            {
              text: 'Depreciation', level: 1,
              link: '/common/joblistview/acDepreciationAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepreciationAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctDepreciationAdjustment,
              secTaskGroup: constants.operations.accounting,     
            },
            {
              text: 'Amortization', level: 1,
              link: '/common/joblistview/acAmortizationAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAmortizationAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctAmortizationAdjustment,
              secTaskGroup: constants.operations.accounting,                   
            },
            {
              text: 'Bad Debt Expense', level: 1,
              link: '/common/joblistview/acBadDebtProcessing/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBadDebtProcessing/accounting'),
              fmsSecTask: FmsSecTask.AcctBadDebtExpense,
              secTaskGroup: constants.operations.accounting,                   
            },
            {
              text: 'Sales Tax Return', level: 1,
              link: '/common/joblistview/acSalesTaxReturn/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acSalesTaxReturn/accounting'),
              fmsSecTask: FmsSecTask.AcctSalesTaxReturnList,
              secTaskGroup: constants.operations.accounting,                   
            },
            {
              text: 'Distribution', level: 1,
              link: '/common/joblistview/acDistribution/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDistribution/accounting'),
              fmsSecTask: FmsSecTask.AcctDistributionPayable,
              secTaskGroup: constants.operations.accounting,                   
            },
            {
              text: 'Advance Sales', level: 1,
              link: '/common/joblistview/acAdvanceSales/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAdvanceSales/accounting'),
              // sideMenuGroup: [SideMenuGroup.AccountingClassify],
              secTaskGroup: constants.operations.accounting,     
            },
          ],
          nonItemThenHide:true
        },
        { //suntekKor이 false일때 사용
          text: 'Journal List',
          level: 0,
          link: '/common/joblistview/acJournal/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acJournal/accounting'),
          topLineColor: '#d9d9da',
          fmsSecTask: FmsSecTask.AcctSlipJournalList,
          metadata:{suntekKor: false},            
        },
        { // 한국 회계 전용
          text: 'Journal List',
          level: 0,
          fmsSecTask: FmsSecTask.AcctSlipJournalList,
          topLineColor: '#d9d9da',
          secTaskGroup: constants.operations.accounting,
          metadata:{suntekKor: true},
          items: [
            {
              text: 'Journal List',
              level: 1,
              link: '/common/joblistview/acJournal/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acJournal/accounting'),
              fmsSecTask: FmsSecTask.AcctSlipJournalList,
              topLineColor: '#d9d9da',
              secTaskGroup: constants.operations.accounting,               
            },
            {
              text : '매입처별 세금계산서', 
              level:1, 
              link:'/accounting/acVatARAPReport/AP', 
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c,'/accounting/acVatARAPReport/VatAP'), 
              secTaskGroup: constants.operations.accounting,   
            },
            {
              text : '매출처별 세금계산서', 
              level:1, 
              link:'/accounting/acVatARAPReport/AR',  
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c,'/accounting/acVatARAPReport/VatAR'), 
              secTaskGroup: constants.operations.accounting,   
            },
          ]               
        },
        {
          text: 'Financial Report',
          level: 0,
          secTaskGroup: constants.operations.accounting,               
          topLineColor: '#d9d9da',
          items: [
            //{text: 'Income Statement', level: 1, popupComponent: <IncomeStatementDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctIncomeStatement},
            {
              text: 'Income Statement',
              level: 1,
              link: '/accounting/acIncomeStatement',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acIncomeStatement'),
              fmsSecTask: FmsSecTask.AcctIncomeStatement,
              secTaskGroup: constants.operations.accounting,                   
            },
            // {text: 'Balance Sheet', level: 1, popupComponent: <BalanceSheetDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctBalanceSheet},
            {
              text: 'Balance Sheet',
              level: 1,
              link: '/accounting/acBalanceSheet',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acBalanceSheet'),
              fmsSecTask: FmsSecTask.AcctBalanceSheet,
              secTaskGroup: constants.operations.accounting,                   
            },
            //  {text: 'Trial Balance', level: 1, popupComponent: <TrialBalanceDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctTrialBalance},
            {
              text: 'Trial Balance',
              level: 1,
              link: '/accounting/acTrialBalance',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acTrialBalance'),
              fmsSecTask: FmsSecTask.AcctTrialBalance,
              secTaskGroup: constants.operations.accounting,                   
            },
          ],
          nonItemThenHide:true
        },
        {
          text: 'Period Closing',
          level: 0,
          popupComponent: <PeriodClosingDetails />,
          popupWidth: 600,
          fmsSecTask: FmsSecTask.AcctPeriodClosing,
          topLineColor: '#d9d9db',
          secTaskGroup: constants.operations.accounting,               
        },
        {
          text: 'Year End Processing',
          level: 0,
          popupWidth: 510,
          popupTop: 50,
          popupComponent: <YearEndProcessingDetails />,
          fmsSecTask: FmsSecTask.AcctEndYearProc,
          topLineColor: '#d9d9db',
          secTaskGroup: constants.operations.accounting,     
        },
      ],
      report: [],
      moreMenu: [
        {
          text: 'Bank EDI (ARP)',
          level: 1,
          moreMenuJobName: JobNames.BillPayment,
          name: 'bankEDI', 
          popupWidth: 760,
          popupComponent: <></>
        },
        { text: 'Print Check Attachment', level: 1, subMenu: FmsSubMenu.PrintCheckSlip, moreMenuJobName: JobNames.BillPayment },
        { text: 'Print Messenger Slip', level: 1, subMenu: FmsSubMenu.PrintMessengerSlip, moreMenuJobName: JobNames.BillPayment },
      ]
      // moreMenu: [
      //   {
      //     text: 'More Menu',
      //     level: 0,
      //     items: [
      //       //Bill Pay More Menu
      //       // {text: 'Bank EDI (ARP)', level: 1, popupComponent: <BankEdi jobName={JobNames.BillPayment} selectedElementId={null} />, moreMenuJobName: JobNames.BillPayment },
      //       // {text: 'Print Check Attachment', level: 1, subMenu: FmsSubMenu.PrintCheckSlip, moreMenuJobName: JobNames.BillPayment},
      //       // { text: 'Print Messenger Slip', level: 1, subMenu: FmsSubMenu.PrintMessengerSlip, moreMenuJobName: JobNames.BillPayment },

      //       //Check Clear More Menu
      //       // {text: 'New Customer Pay',level: 1, moreMenuJobName: JobNames.CheckClear },
      //       // {text: 'New Bill Pay',level: 1, moreMenuJobName: JobNames.CheckClear  },
      //     ]
      //   },
      // ]
    },
    // Customer
    {
      operation: constants.operations.customer,
      job: [
        // {
        //   text: 'Agent Statement',
        //   level: 0,
        // },
        // {
        //   text: 'Customer Statement',
        //   level: 0,
        // },
        // {
        //   text: 'Email',
        //   level: 0,
        // },
        // {
        //   text: 'Fax',
        //   level: 0,
        // },
        // {
        //   text: 'Importer/Bond Query',
        //   level: 0,
        // },
        // {
        //   text: 'Last Transaction',
        //   level: 0,
        // },
        // {
        //   text: 'Memo List (Customer)',
        //   level: 0,
        // },
        // {
        //   text: 'PrePickup Order',
        //   level: 0,
        // },
        // {
        //   text: 'Print Customer Profile',
        //   level: 0,
        // },
        {
          text: 'Customer List', level: 0,
          link: '/common/joblistview/company/customer',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/company/customer'),
          fmsSecTask: FmsSecTask.CodeCompany,
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Active/In-Action CUST Report', 
          level: 0,
          link: '/company/activeCustomer',
          fmsSecTask: FmsSecTask.OPRptCustomerActivity,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/activeCustomer'),
        },
      ],
      report: [],
      moreMenu: [
        //Company More Menu
        {
          text: 'Agent Statement',
          level: 1,
          link: '/company/agentStatement?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/agentStatement/'),
          moreMenuJobName: JobNames.Company,
          fmsSecTask: FmsSecTask.AcctAgentStatement,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Customer Statement',
          level: 1,
          link: '/company/customerVendor?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/customerVendor/'),
          moreMenuJobName: JobNames.Company,
          fmsSecTask: FmsSecTask.AcctCustStatement,
        },
        {
          text: 'PrePickup Order',
          level: 1,
          link: '/company/pickupDelivery?jobname=@jobName&id=@jobid&docType=127',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/pickupDelivery/'),
          moreMenuJobName: JobNames.Company,
        },
        {
          text: 'Print Customer Profile',
          level: 1,
          subMenu: FmsSubMenu.CompanyProfile,
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Tracking Portal Customers',
          level: 1,
          link: '/company/internetTrackingCustomers?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/internetTrackingCustomers/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Email', level: 1,
          subMenu: FmsSubMenu.SendEmail,
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        // 250611.inhyung. Fax hiding 처리 했음.
        // 
        // {
        //   text: 'Fax',
        //   level: 1,
        //   subMenu: FmsSubMenu.SendFax, moreMenuJobName: JobNames.Company
        // },
        {
          text: 'Importer/Bond Query',
          level: 1,
          link: '/company/importerBondQuery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/importerBondQuery/'),
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        {
          text: 'Last Transaction',
          level: 1,
          link: '/company/lastTransaction?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/lastTransaction/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/company/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/memoList/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Customer Address Label Print',
          level: 1,
          link: '/company/companyAddressLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/companyAddressLabel/'),
          moreMenuJobName: JobNames.Company,
          fmsSecTask: FmsSecTask.UTCmpAddrPrint,
        },
        {
          text: 'Type Code', 
          level: 1, 
          link: '/company/TypeCode?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/TypeCode/'),
          moreMenuJobName: JobNames.Company,
          // fmsSecTask: FmsSecTask.CodeGroup,
        },
        // { text: 'Customer Statement', level: 1, popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType={''} />, moreMenuJobName: JobNames.Company },
        // { text: 'PrePickup Order', level: 1, popupComponent: <PickupDelivery jobName={JobNames.Company} docType={DocumentType.PrePickup} selectedElementId={null} />, moreMenuJobName: JobNames.Company },
        // { text: 'Print Customer Profile', level: 1, subMenu: FmsSubMenu.CompanyProfile, moreMenuJobName: JobNames.Company, topLineColor: borderColors[1 % borderColors.length] },
        // { text: 'Importer/Bond Query', level: 1, popupComponent: <ImporterBondQuery selectedElement={null} />, popupWidth: 550, moreMenuJobName: JobNames.Company, topLineColor: borderColors[3 % borderColors.length] },
        // { text: 'Last Transaction', level: 1, popupComponent: <LastTransaction selectedElement={null} />, moreMenuJobName: JobNames.Company },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} isCompany={true} />, moreMenuJobName: JobNames.Company },
        // {
        //   text: 'Customer Address Label Print',
        //   level: 0,
        //   popupComponent: <CompanyAddressLabel />,
        //   popupWidth: 550,
        //   fmsSecTask: FmsSecTask.CmpAddrPrint,
        // },
      ]
    },
    //OP Report
    {
      operation: constants.operations.opReport,
      job: [
        {
          text: 'Duty Report', level: 0,
          link: '/opReport/dutyReport',
          fmsSecTask: FmsSecTask.OPRptDutyReport,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/dutyReport'),
        },
        {
          text: 'Duty Pending', level: 0,
          link: '/opReport/dutyPendings',
          fmsSecTask: FmsSecTask.OPRptDutyPendings,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/dutyPendings'),
        },
        {
          text: 'Billings Pending', level: 0,
          link: '/opReport/issueReady',
          fmsSecTask: FmsSecTask.OPRptIssueReady,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/issueReady'),
        },
        {
          text: 'Est. Profit / Volume', level: 0,
          link: '/opReport/estProfit?docType=705&isManagerReport=true&opType=oceanImport',
          fmsSecTask: FmsSecTask.OPRptEstProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/estProfit'),
        },
        {
          text: 'Recog Profit / Volume', level: 0,
          link: '/opReport/recogProfit?docType=23&isManagerReport=true&opType=oceanImport',
          fmsSecTask: FmsSecTask.OPRptRecogProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/recogProfit'),
        },
        {
          text: 'Cost / Expense', level: 0,
          link: '/opReport/cost',
          fmsSecTask: FmsSecTask.OPRptVendorCost,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/cost'),
        },
        // {
        //   text: 'Expense Report', level: 0,
        //   link: '/opReport/expense',
        //   fmsSecTask: FmsSecTask.OPRptExpense,
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/expense'),
        // },
        {
          text: 'Volume / Weight', level: 0,
          link: '/opReport/volume',
          fmsSecTask: FmsSecTask.OPRptVolume,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/volume'),
        },
        {
          text: 'Salesperson Performance', level: 0,
          link: '/opReport/salesPerformance?docType=206&isManagerReport=true&opType=oceanImport',
          fmsSecTask: FmsSecTask.OPRptProfitBySalesman,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/salesPerformance'),
        },
        // {
        //   text: 'Customer Activity Report', level: 0,
        //   link: '/opReport/customerActivity',
        //   fmsSecTask: FmsSecTask.OPRptCustomerActivity,
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/customerActivity'),
        // },
        {
          text: 'Operator Performance', level: 0,
          link: '/opReport/opPerformance',
          fmsSecTask: FmsSecTask.OPRptOpPerfom,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/opPerformance'),
        },
        {
          text: 'Branch Performance', level: 0,
          link: '/opReport/branchPerformance',
          fmsSecTask: FmsSecTask.OPRptBranchPerform,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/branchPerformance'),
        },
        {
          text: 'Analysis by Billing Code', level: 0,
          link: '/opReport/profitByBillCode',
          fmsSecTask: FmsSecTask.OPRptProfitByBillCode,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/profitByBillCode'),
        },
        {
          text: 'Special Report',
          level: 0,
          link: '/common/joblistview/QURY/opReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/QURY/opReport'),
          fmsSecTask: FmsSecTask.OPRptSpecial
        },
        // {
        //   text: 'Invoice', level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: '#d9d9d9' 
        // },
        // {
        //   text: 'Bill', level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList
        // },
        // {
        //   text: 'CrDb', level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList
        // },
      ],
      // job: [
      //   {text: 'Issue Ready Report', level: 0, fmsSecTask: FmsSecTask.OPRptIssueReady},
      //   {text: 'Volume Report', level: 0, popupComponent: <VolumeReportDetails opType={'oceanImport'} />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptVolume },
      // ],
      report: [],
    },
    //Utility
    {
      operation: constants.operations.utility,
      job: [
        {
          text: 'Communication Log List',
          level: 0,
          link: '/common/joblistview/utCommunication/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utCommunication/utility'),
          fmsSecTask: FmsSecTask.UTCommunication,
          secTaskGroup: constants.operations.utility
        },
        {
          text: 'Email Log List',
          level: 0,
          link: '/common/joblistview/utEmail/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utEmail/utility'),
          fmsSecTask: FmsSecTask.UTEmailLog,
          secTaskGroup: constants.operations.utility
        },
        {
          text: 'Print Log List',
          level: 0,
          link: '/common/joblistview/utPrint/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utPrint/utility'),
          fmsSecTask: FmsSecTask.UTPrintLog,
          secTaskGroup: constants.operations.utility
        },
        {
          text: 'Fax Log List',
          level: 0,
          link: '/common/joblistview/utFax/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utFax/utility'),
          fmsSecTask: FmsSecTask.UTFaxLog,
          secTaskGroup: constants.operations.utility
        },
        { //CMS User만 접근 가능
          text: 'AMS/ISF Log List',
          level: 0,
          link: '/common/joblistview/utAmsIsf/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utAmsIsf/utility'),
          secTaskGroup: ''
        },
        {
          text: 'Memo List',
          level: 0,
          link: '/common/joblistview/utMemotask/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utMemotask/utility'),
          fmsSecTask: FmsSecTask.UTTaskMemoList,
          secTaskGroup: constants.operations.utility
        },
        {
          text: 'Attached File List',
          level: 0,
          link: '/common/joblistview/utAttachedfile/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utAttachedfile/utility'),
          fmsSecTask: FmsSecTask.UTAttachedFile,
          secTaskGroup: constants.operations.utility
        },
        {
          text: 'Email Template List',
          level: 0,
          link: '/common/joblistview/utEmailTemplate/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utEmailTemplate/utility'),
          secTaskGroup: constants.operations.utility
        },
        {
          //text: appContext.systemSettings?.showMilestoneInOihList ? 'B/L Activity Status Off (OIH List)': 'B/L Activity Status On (OIH List)',
          text: 'OIH B/L Activity Status On',
          level: 0,
          //link: '/common/joblistview/utFax/utility', 
          //fmsSecTask: FmsSecTask.UTFaxLog
          secTaskGroup: '',
        },
        {
          //text: appContext.systemSettings?.showMilestoneInAihList ? 'B/L Activity Status Off (AIH List)': 'B/L Activity Status On (AIH List)',
          text: 'AIH B/L Activity Status On',
          level: 0,
          //link: '/common/joblistview/utFax/utility', 
          //fmsSecTask: FmsSecTask.UTFaxLog
          secTaskGroup: '',
        },
        {
          text: `Denied Party (BIS)`,
          level: 0,
          link: 'https://www.bis.doc.gov/index.php/policy-guidance/lists-of-parties-of-concern',
          //metadata: { isDirectPrint: true },
          secTaskGroup: '',
          iconImg : IconTypes.multiplewindows
        },
        {
          text: `Denied Party (OFAC)`,
          level: 0, link: 'https://www.treas.gov/offices/enforcement/ofac/sdn/',
          //metadata: { isDirectPrint: true },
          secTaskGroup: '',
          iconImg : IconTypes.multiplewindows
        },
        {
          text: `Denied Party (ITAR)`,
          level: 0, link: 'https://www.pmddtc.state.gov/',
          //metadata: { isDirectPrint: true },
          secTaskGroup: '',
          iconImg : IconTypes.multiplewindows
        },
        // {
        //   text: 'Denied Party (BIS)',
        //   level: 0,
        //   link: 'https://www.bis.doc.gov/index.php/policy-guidance/lists-of-parties-of-concern'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   text: 'Denied Party (OFAC)',
        //   level: 0,
        //   link: 'https://www.treas.gov/offices/enforcement/ofac/sdn/'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   text: 'Denied Party (ITAR)',
        //   level: 0,
        //   link: 'https://www.pmddtc.state.gov/'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        {
          text: 'Check File Server',
          level: 0,
          //fmsSecTask: FmsSecTask.UTFaxLog
          secTaskGroup: '',
        },
      ],
      preReport: [],
      report: []
    },
    //Billings
    {
      operation: constants.operations.billings,
      job: [
        {
          text: 'Invoice',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
        },
        {
          text: 'Bill',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList,
        },
        {
          text: 'CrDb',
          level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList,
        },
        {
          text: 'G. Invoice',
          level: 0,
          link: '/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralInvoice/accounting'),
          fmsSecTask: FmsSecTask.AcctGInvoList,
        },
        {
          text: 'G. Bill',
          level: 0,
          link: '/common/joblistview/acGeneralBill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralBill/accounting'),
          fmsSecTask: FmsSecTask.AcctGBillList,
        },
        // View History  -----------------------------
        {
          text: 'View History',
          level: 0,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
        },
        // ↓ 선택된 Invoice / Bill / CrDb 의 컨텍스트 메뉴(Delete History, Print, Batch Print ...)가 이 자리에 들어간다 (IfmsMain)
        { text: 'More Menu Slot', level: 0, metadata: { moreMenuSlot: true } },
        // New Customer Pay  -----------------------------
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4'
        },
      
        // New Bill Pay  -----------------------------
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#0079a4'
        },
        // Customer Pay List  -----------------------------
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        // Bill Pay List  -----------------------------
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
          topLineColor: '#ffc000',
        },
        // View Payment History  -----------------------------
        {
          text: 'View Payment History',
          level: 0,
          subMenuNonReport: FmsSubMenu.ViewPaymenHistory,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acPaymentHistoryView'),
          topLineColor: '#ffc000',
        },
        // Customer Statement  -----------------------------
        {
          text: 'Customer Statement',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerStatement,
          fmsSecTask: FmsSecTask.AcctCustStatement,
          // link: '/accounting/acCustomerStatement?parentOp=billings',
          // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCustomerStatement'),
          topLineColor: '#ff0000',
        },
     
        // Agent Statement  -----------------------------
        {
          text: 'Agent Statement',
          level: 0,
          subMenuNonReport: FmsSubMenu.AgentStatement,
          fmsSecTask: FmsSecTask.AcctAgentStatement,
          // link: '/accounting/acAgentStatement?parentOp=billings',
          // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAgentStatement'),
          topLineColor: '#ff0000',
        },
        // View Journal  -----------------------------
        {
          text: 'Journal List',
          level: 0,
          //moreMenuJobName: JobNames.OpInvoice,
          fmsSecTask: FmsSecTask.AcctSlipJournalList,
          link: '/common/joblistview/acJournal/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acJournal/accounting'),
          //subMenuNonReport: FmsSubMenu.SwitchJournal,
          topLineColor: '#84e291',
        },

      ],
      preReport: [],
      report: [],
      moreMenu: [
        // Delete History  -----------------------------
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.Bill,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.CrDb,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.GBill,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        // Auto Billing (G. Invoice Only)  -----------------------------
        {
          text: 'Auto Billing',
          level: 1,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          moreMenuJobName: JobNames.GInvo,
          subMenuNonReport: FmsSubMenu.AutoBillingView,
         // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAutobilling'),
        },
        // Print  -----------------------------
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpInvoice,
          subMenu: FmsSubMenu.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          subMenu: FmsSubMenu.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpBill,
          fmsSecTask: FmsSecTask.AcctBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.Bill,
          fmsSecTask: FmsSecTask.AcctBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpCrDb,
          fmsSecTask: FmsSecTask.AcctCrDbList,
          subMenu: FmsSubMenu.CrDbNote,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.CrDb,
          fmsSecTask: FmsSecTask.AcctCrDbList,
          subMenu: FmsSubMenu.CrDbNote,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          subMenu: FmsSubMenu.Invoice,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          fmsSecTask: FmsSecTask.AcctGBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          moreMenuJobName: JobNames.GBill,
          topLineColor: '#cc00ff'
        },
        // ===== OpInvoice =====
        {
          text: 'Batch Print',
          level: 1,
          moreMenuJobName: JobNames.OpInvoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          link: '/accounting/batchPrint/invoice/add?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/batchPrint/invoice/add'),
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Batch Print History',
          level: 1,
          moreMenuJobName: JobNames.OpInvoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          link: '/common/joblistview/acBatchPrintHistory/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchPrintHistory/accounting'),
          secTaskGroup: constants.operations.accounting,
        },
        // ===== Invoice =====
        {
          text: 'Batch Print',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          link: '/accounting/batchPrint/invoice/add?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/batchPrint/invoice/add'),
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Batch Print History',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          link: '/common/joblistview/acBatchPrintHistory/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchPrintHistory/accounting'),
          secTaskGroup: constants.operations.accounting,
        },
        // ===== General Invoice =====
        {
          text: 'Batch Print',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          link: '/accounting/batchPrint/invoice/add?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/batchPrint/invoice/add'),
          secTaskGroup: constants.operations.accounting,
        },
        {
          text: 'Batch Print History',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          link: '/common/joblistview/acBatchPrintHistory/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBatchPrintHistory/accounting'),
          secTaskGroup: constants.operations.accounting,
        },
      ],

    },
    //My Event
    {
      operation: constants.operations.myEvent,
      job:[
        {
          text: 'Master B/L',
          name: 'mbl',
          level: 0,
          link: '/common/joblistview/mbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/mbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIMbl,
        },
        {
          text: 'House B/L',
          name: 'hbl',
          level: 0,
          link: '/common/joblistview/hbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/hbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIHbl,
        },
      ],
      preReport: [],
      report: []
    },
    //AMS
    {
      operation : constants.operations.ams,
      job:[
        {
          text: 'AMS Filing',
          name: 'amsFiling',
          level: 0,
          subMenu: FmsSubMenu.AmsFiling,
          fmsSecTask :  FmsSecTask.AMSAMSFiling,
          secTaskGroup: constants.operations.ams,
        },
        {
          text: 'Voyage',
          name: 'voyage',
          level: 0,
          link: '/common/joblistview/AMSV/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSV/ams'),
          fmsSecTask: FmsSecTask.AMSVoyage,
          secTaskGroup: constants.operations.ams,
        },
        {
          text: 'AMS MBL',
          name: 'amsMbl',
          level: 0,
          link: '/common/joblistview/AMSM/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSM/ams'),
          fmsSecTask: FmsSecTask.AMSMaster,
          secTaskGroup: constants.operations.ams,          
        },
        {
          text: 'AMS HBL',
          name: 'amsHbl',
          level: 0,
          link: '/common/joblistview/AMSH/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSH/ams'),
          fmsSecTask: FmsSecTask.AMSHouse,
          secTaskGroup: constants.operations.ams,          
        },
        {
          text: 'User',
          name: 'amsUser',
          level: 0,
          link: '/common/joblistview/AMSU/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSU/ams'),
          fmsSecTask: FmsSecTask.AMSUser,
          secTaskGroup: constants.operations.ams,          
        },
        {
          text: 'AMS Branch',
          name: 'amsBranch',
          level: 0,
          link: '/common/joblistview/AMBR/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBR/ams'),
          fmsSecTask: FmsSecTask.AMSBranch,
          secTaskGroup: constants.operations.ams,          
        },
        // {
        //   text: 'AMS Billing Code',
        //   name: 'amsBilling',
        //   level: 0,
        //   link: '/common/joblistview/AMBI/ams',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBI/ams'),
        //   fmsSecTask: FmsSecTask.AMSBilling,
        //   secTaskGroup: constants.operations.ams,          
        // },
        {
          text: 'Filing History',
          name: 'amsFileHistory',
          level: 0,
          link: '/common/joblistview/AMHI/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMHI/ams'),
          fmsSecTask: FmsSecTask.AMSHistory,
          secTaskGroup: constants.operations.ams,          
        },
        // {
        //   text: 'Customs Release History',
        //   name: 'amsCustHistory',
        //   level: 0,
        //   link: '/common/joblistview/AMC1/ams',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMC1/ams'),
        //   fmsSecTask: FmsSecTask.AMSC1History,
        //   secTaskGroup: constants.operations.ams,          
        // }, 
        {
          text: 'Usage Report',
          level: 0,
          link: '/ams/amsUsageReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsUsageReport'),
          fmsSecTask: FmsSecTask.AMSRptUsage,
          secTaskGroup: constants.operations.ams,          
        }, {
          text: 'Lifting Report',
          level: 0,
          link: '/ams/amsLiftReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsLiftReport'),
          fmsSecTask: FmsSecTask.AMSRptLifting,
          secTaskGroup: constants.operations.ams,          
        }, {
          text: 'Total Lifting Report',
          level: 0,
          link: '/ams/amsTotLiftReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsTotLiftReport'),
          fmsSecTask: FmsSecTask.AMSRptTotalLifting,
          secTaskGroup: constants.operations.ams,
        },
        {
          text: 'ACI eManifest Filing',
          name: 'aciFiling',
          level: 0,
          subMenu: FmsSubMenu.AciFiling,
          secTaskGroup: 'constants.operations.ams',
          fmsSecTask: FmsSecTask.ACIACIFiling,
          topLineColor: borderColors[4 % borderColors.length],

        },

        {
          text: 'ACI eManifest House Bill',
          name: 'aciHbl',
          level: 1,
          link: '/common/joblistview/ACIEM/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIEM/ams'),
          fmsSecTask: FmsSecTask.ACIManifest,
          topLineColor: borderColors[4 % borderColors.length],
          secTaskGroup: constants.operations.ams,
          
        },

        {
          text: 'ACI eManifest Usage Report',
          level: 1,
          link: '/ams/aciUsageReport/',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/aciUsageReport/'),
          fmsSecTask: FmsSecTask.ACIUsageReport,
           topLineColor: borderColors[4 % borderColors.length],
          secTaskGroup: constants.operations.ams,
         
        },


      ],
      preReport: [],
      report: []
    },
    //ISF
    {
      operation: constants.operations.isf,
      job:[
        {
          text: 'ISF List',
          name: 'isfList',
          level: 0,
          link: '/common/joblistview/ISFL/isf',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ISFL/isf'),
          fmsSecTask: FmsSecTask.ISF,
        },
        {
          text: 'ISF Filing',
          name: 'isfFiling',
          level: 0,
          subMenu: FmsSubMenu.IsfFiling,
        },
        {
          text: 'ISF Upload',
          name: 'isfUpload',
          level: 0,
          subMenu: FmsSubMenu.IsfUpload,
        },
        {
          text: 'Std. ISF Excel Form (Download)',
          name: 'isfExcelDownload',
          level: 0
        },
        {
          text: 'Download',
          name: 'download',
          level: 0,
          link: '/oceanImport/download/isf/@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/download/isf'),
        },
        {
          text: 'ISF Detail',
          name: 'isfDetail',
          level: 0,
          subMenu: FmsSubMenu.IsfDetail,
          nonSubMenuIcon: true
        },
        {
          text: 'ISF Usage',
          name: 'isfUsage',
          level: 0,
          link: '/isf/isfUsage',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/isf/isfUsage'),
        },
      ],
      preReport: [],
      report: []
    },
    //AES
    {
      operation: constants.operations.aes,
      job:[
        {
          text: 'AES List',
          name: 'aesList',
          level: 0,
          link: '/common/joblistview/AESFI/aes',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AESL/aes'),
          fmsSecTask: FmsSecTask.AES,
        },
        {
          text: 'EEI Report',
          name: 'aesEei',
          level: 0,
          subMenuNonReport: FmsSubMenu.AesEei,
          subMenu: FmsSubMenu.AesEei,
        },
        {
          text: 'AES Response',
          name: 'aesResponse',
          level: 0,
          subMenuNonReport: FmsSubMenu.AesResponse,
          subMenu: FmsSubMenu.AesResponse,
        },
        {
          text: 'AES Usage Report',
          name: 'aesUsageReport',
          level: 0,
          subMenuNonReport: FmsSubMenu.AesUsageReport,
          subMenu: FmsSubMenu.AesUsageReport,
        },
        {
          text: 'AES Site',
          name: 'aesSite',
          level: 0,
          subMenuNonReport: FmsSubMenu.AesSite,
          subMenu: FmsSubMenu.AesSite,
        },
      ],
      preReport: [],
      report: []
    },
    //Shipment Status 
    {
      operation: constants.operations.shipmentStatus,
      job: [
        {
          text: 'Shipment Control Tower', level: 0,
          link: '/common/joblistview/RPCSP/shipmentStatus',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/RPCSP/shipmentStatus'),
          fmsSecTask: FmsSecTask.RptCustomerShipment,
        },
        {
          text: 'Container Tracking Usage',
          name: 'cntrTrkUsage',
          level: 0,
          link: '/shipmentStatus/cntrTrkUsage',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/shipmentStatus/cntrTrkUsage'),
        },
        {
          text: 'Report Scheduling',
          level: 0,
          link: '/common/joblistview/RPTSD/shipmentStatus',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/RPTSD/shipmentStatus'),
        },
        {
          text: 'Report History',
          level: 0,
          link: '/common/joblistview/RPHIS/shipmentStatus',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/RPHIS/shipmentStatus'),
        },
      ],
      preReport: [],
      report: []
    },
    //All Container List
    {
        operation: constants.operations.cntr,
        job: [
            {
                text: 'Container List',
                name: 'allCntr',
                level: 0,
                link: '/common/joblistview/allContainer/cntr',
                isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/allContainer/cntr'),
                fmsSecTask: FmsSecTask.AllContainer,
            },
        ],
        preReport: [],
        report: []
    },
    //My Task - Task List 
    {
      operation: constants.operations.myTask,
      job: [
        {
          text: 'Task List', level: 0,
          link: '/common/joblistview/TASKL/myTask',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/TASKL/myTask'),
          fmsSecTask: FmsSecTask.TaskList,
        },
      ],
      preReport: [],
      report: []
    },

    //AI Center - AI Center
    {
      operation: constants.operations.aiCenter,
      job: [
        {
          text: 'AI Center', level: 0,
          link: '/common/joblistview/AICTR/aiCenter',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AICTR/aiCenter'),
        },
      ],
      preReport: [],
      report: []
    },

  ],
};


export default config;